import {
  useLazyGetAllStatesQuery,
  useLazyGetAllTehsilQuery,
  useLazyGetAllVillagesQuery,
  useLazyGetAllDistrictsQuery,
  useGetProductCategoriesQuery,
} from '../../../../services/common';
import { TCompanyDetails } from '../../../../utils/types';
import { useEffect, useState } from 'react';
import { ProductCategory } from '../../../../utils/types';

export const API = (
  enterpriseDetails: TCompanyDetails | undefined
) => {
  const [productCategories, setProductCategories] =
    useState<{ name: string }[]>([]);
  const [stateName, setStateName] = useState<string>();
  const [districtName, setDistrictName] =
    useState<string>();
  const [villageName, setVillageName] = useState<string>();
  const [tehsilName, setTehsilName] = useState<string>();

  const { data: productCategoriesData } =
    useGetProductCategoriesQuery();
  const [getAllState] = useLazyGetAllStatesQuery();
  const [getAllDistrict] = useLazyGetAllDistrictsQuery();
  const [getAllTehsil] = useLazyGetAllTehsilQuery();
  const [getAllVillage] = useLazyGetAllVillagesQuery();

  useEffect(() => {
    if (enterpriseDetails) {
      const enterpriseProductCategories =
        enterpriseDetails?.allowedCategoryCodes.split(',');
      const categoriesData: ProductCategory[] = [];
      enterpriseProductCategories?.forEach((code) => {
        const getCategory = productCategoriesData?.find(
          (value) => value.steuc === code
        );
        if (getCategory) {
          categoriesData.push(getCategory);
        }
      });
      setProductCategories(categoriesData);

      handleAllStates(enterpriseDetails?.state);

      if (enterpriseDetails.districtId != '-1') {
        handleAllDistricts(
          enterpriseDetails.state,
          enterpriseDetails.districtId
        );
      } else {
        setDistrictName(enterpriseDetails.district);
      }

      if (enterpriseDetails.tehsilId != '-1') {
        handleAllTehsil(
          enterpriseDetails.districtId,
          enterpriseDetails.tehsilId
        );
      } else {
        setTehsilName(enterpriseDetails.tehsil);
      }

      if (enterpriseDetails.villageId != '-1') {
        handleAllVillages(
          enterpriseDetails.tehsilId,
          enterpriseDetails.villageId
        );
      } else {
        setVillageName(enterpriseDetails.village);
      }
    }
  }, [enterpriseDetails]);

  const handleAllStates = (serverId: string) => {
    if (serverId && enterpriseDetails) {
      getAllState()
        .unwrap()
        .then((response) => {
          response.map((state) => {
            if (state?.serverId === parseInt(serverId)) {
              setStateName(state.geographyName);
            }
          });
        });
    }
  };

  const handleAllDistricts = (
    parentId: string,
    serverId: string
  ) => {
    if (parentId && serverId) {
      getAllDistrict(parentId)
        .unwrap()
        .then((response) => {
          response.map((district) => {
            if (district.serverId === parseInt(serverId)) {
              setDistrictName(district.geographyName);
            }
          });
        });
    }
  };

  const handleAllTehsil = (
    parentId: string,
    serverId: string
  ) => {
    if (parentId && serverId) {
      getAllTehsil(parentId)
        .unwrap()
        .then((response) => {
          response.map((tehsil) => {
            if (tehsil.serverId === parseInt(serverId)) {
              setTehsilName(tehsil.geographyName);
            }
          });
        });
    }
  };

  const handleAllVillages = (
    parentId: string,
    serverId: string
  ) => {
    if (parentId && serverId) {
      getAllVillage(parentId)
        .unwrap()
        .then((response) => {
          response.map((village) => {
            if (village.serverId === parseInt(serverId)) {
              setVillageName(village.geographyName);
            }
          });
        });
    }
  };

  return {
    productCategories,
    stateName,
    districtName,
    tehsilName,
    villageName,
  };
};
